<div class="row">
  <div class="col-md-12 order-md-2">
    <div
      class="tab-content"
      id="myTabContent"
    >
      <div
        class="tab-pane fade"
        [ngClass]="{ 'show active': this.activeTab === 'profile' }"
        id="profile"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <ng-container *ngIf="isLoadingProfile">
          <div class="perfil-skeleton">
            <div
              class="merge-card"
              *ngIf="isSchool"
            >
              <app-card
                [customHeader]="true"
                blockClass="border-top pro-det-edit collapse show"
                cardTitle="Información del Servicio"
              >
                <h5 class="app-card-header mb-3">
                  <span
                    class="skeleton skeleton-title d-inline-block"
                    style="width: 12rem"
                  ></span>
                </h5>
                <div
                  class="form-group row"
                  *ngFor="let _ of skeletonServiceRows"
                >
                  <div class="col-sm-3 pt-1">
                    <span
                      class="skeleton skeleton-text"
                      style="width: 4rem"
                    ></span>
                  </div>
                  <div class="col-sm-9 d-flex align-items-center">
                    <span
                      class="skeleton skeleton-text"
                      style="width: 55%"
                    ></span>
                  </div>
                </div>
              </app-card>
            </div>

            <div class="merge-card">
              <app-card
                [customHeader]="true"
                blockClass="border-top pro-det-edit collapse show"
                cardTitle="Datos Personales"
              >
                <h5 class="app-card-header mb-3">
                  <span
                    class="skeleton skeleton-title d-inline-block"
                    style="width: 11rem"
                  ></span>
                </h5>
                <div
                  class="form-group row"
                  *ngFor="let _ of skeletonDataRows"
                >
                  <div class="col-sm-3 pt-1">
                    <span
                      class="skeleton skeleton-text"
                      style="width: 5.5rem"
                    ></span>
                  </div>
                  <div class="col-sm-9 d-flex align-items-center">
                    <span
                      class="skeleton skeleton-text"
                      style="width: 70%"
                    ></span>
                  </div>
                </div>
              </app-card>
            </div>

            <div class="merge-card">
              <app-card
                [customHeader]="true"
                blockClass="border-top pro-det-edit collapse show"
              >
                <div class="app-card-header d-flex justify-content-between align-items-center mb-0">
                  <span
                    class="skeleton skeleton-title d-inline-block"
                    style="width: 13rem"
                  ></span>
                  <span class="skeleton skeleton-btn d-inline-block"></span>
                </div>
                <div
                  class="form-group row mt-3"
                  *ngFor="let _ of skeletonContactRows"
                >
                  <div class="col-sm-3 pt-1">
                    <span
                      class="skeleton skeleton-text"
                      style="width: 6rem"
                    ></span>
                  </div>
                  <div class="col-sm-9 d-flex align-items-center">
                    <span
                      class="skeleton skeleton-text"
                      style="width: 65%"
                    ></span>
                  </div>
                </div>
              </app-card>
            </div>

            <div class="merge-card">
              <app-card
                [customHeader]="true"
                blockClass="border-top pro-det-edit collapse show"
                cardTitle="Seguridad de la cuenta"
              >
                <div class="app-card-header perfil-password-card-header">
                  <div class="d-flex justify-content-between align-items-start perfil-password-header-top">
                    <div class="perfil-password-header-titles w-100 pe-2">
                      <span
                        class="skeleton skeleton-title d-block mb-2"
                        style="width: 11rem; height: 1.25rem"
                      ></span>
                      <span
                        class="skeleton skeleton-text d-block"
                        style="width: 16rem; max-width: 100%; height: 0.875rem"
                      ></span>
                    </div>
                    <span class="skeleton skeleton-icon d-inline-block flex-shrink-0"></span>
                  </div>
                </div>
                <div class="perfil-password-card-header">
                  <span
                    class="skeleton skeleton-text d-block mt-2 perfil-skeleton-hint-line"
                  ></span>
                </div>
                <div class="pt-3">
                  <div
                    class="form-group row"
                    *ngFor="let _ of skeletonPasswordRows"
                  >
                    <div class="col-sm-3 pt-2">
                      <span
                        class="skeleton skeleton-text"
                        style="width: 7.5rem"
                      ></span>
                    </div>
                    <div class="col-sm-9">
                      <div class="skeleton skeleton-input w-100"></div>
                    </div>
                  </div>
                  <div class="form-group row submit-row mt-2">
                    <div class="col-sm-3 d-none d-sm-block"></div>
                    <div class="col-sm-9">
                      <span class="skeleton skeleton-button d-inline-block"></span>
                    </div>
                  </div>
                </div>
              </app-card>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoadingProfile">
        <div class="merge-card">
          <app-card
            [customHeader]="true"
            blockClass="border-top pro-det-edit collapse show"
            *ngIf="isSchool"
            cardTitle="Información del Servicio"
          >
            <h5 class="app-card-header">Información del Servicio</h5>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label font-weight-bolder">Estado</label>
              <div class="col-sm-9 align-items-center d-flex">
                <div class="badge bg-success">
                  {{ serviceStatus }}
                </div>
              </div>
            </div>
            <ng-container *ngIf="institutionalService">
              <div
                class="form-group row"
                *ngIf="hasContractedPlan"
              >
                <label class="col-sm-3 col-form-label font-weight-bolder">Plan contratado</label>
                <div class="col-sm-9 align-items-center d-flex flex-wrap">
                  <span
                    class="perfil-plan-metric perfil-plan-metric--down"
                    *ngIf="institutionalService.contractedPlan?.downloadMbps != null"
                    ngbTooltip="Bajada"
                    container="body"
                  >
                    <i
                      class="feather icon-arrow-down me-1"
                      aria-hidden="true"
                    ></i>
                    <span class="visually-hidden">Bajada </span>
                    {{ institutionalService.contractedPlan?.downloadMbps }} Mbps
                  </span>
                  <span
                    class="perfil-plan-metric perfil-plan-metric--up"
                    *ngIf="institutionalService.contractedPlan?.uploadMbps != null"
                    ngbTooltip="Subida"
                    container="body"
                  >
                    <i
                      class="feather icon-arrow-up me-1"
                      aria-hidden="true"
                    ></i>
                    <span class="visually-hidden">Subida </span>
                    {{ institutionalService.contractedPlan?.uploadMbps }} Mbps
                  </span>
                </div>
              </div>
              <div
                class="form-group row"
                *ngIf="institutionalService.ugel"
              >
                <label class="col-sm-3 col-form-label font-weight-bolder">UGEL</label>
                <div class="col-sm-9 align-items-center d-flex">
                  {{ institutionalService.ugel }}
                </div>
              </div>
              <div
                class="form-group row"
                *ngIf="serviceLocalityLabel"
              >
                <label class="col-sm-3 col-form-label font-weight-bolder">Localidad</label>
                <div class="col-sm-9 align-items-center d-flex">
                  {{ serviceLocalityLabel }}
                </div>
              </div>
            </ng-container>
          </app-card>
        </div>
        <div class="merge-card">
          <app-card
            [customHeader]="true"
            blockClass="border-top pro-det-edit collapse show"
            *ngIf="!editProfile"
            cardTitle="Datos Personales"
          >
            <h5 class="app-card-header">{{ !isSchool && !isUgel ? 'Datos Personales' : 'Datos de la Institución' }}</h5>
            <ng-container *ngIf="user && user.userDetails && user.userType == 'PERSON'">
              <div class="form-group row">
                <label class="col-sm-3 col-form-label font-weight-bolder">DNI</label>
                <div class="col-sm-9 align-items-center d-flex">
                  {{ user.userDetails.dni }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label font-weight-bolder">Apellidos</label>
                <div class="col-sm-9 align-items-center d-flex">
                  {{ user.userDetails.lastName }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label font-weight-bolder">Nombres</label>
                <div class="col-sm-9 align-items-center d-flex">
                  {{ user.userDetails.firstName }}
                </div>
              </div>
              <!--<div class="form-group row">
                <label class="col-sm-3 col-form-label font-weight-bolder">Estado</label>
                <div class="col-sm-9 align-items-center d-flex">
                  <div class="badge bg-success">
                    {{ user.status }}
                  </div>
                </div>
              </div>-->
            </ng-container>

            <ng-container *ngIf="user && user.userDetails && user.userType == 'BUSINESS'">
              <div class="form-group row">
                <label class="col-sm-3 col-form-label font-weight-bolder">
                  {{ !isSchool ? 'RUC' : 'Código Modular' }}
                </label>
                <div class="col-sm-9 align-items-center d-flex">
                  {{ user.userDetails.ruc }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label font-weight-bolder">
                  {{ !isSchool && !isUgel ? 'Razón Social' : 'Nombre' }}
                </label>
                <div class="col-sm-9 align-items-center d-flex">
                  {{ user.userDetails.businessName }}
                </div>
              </div>
              <!--<div class="form-group row">
                <label class="col-sm-3 col-form-label font-weight-bolder">Estado</label>
                <div class="col-sm-9 align-items-center d-flex">
                  <div class="badge bg-success">
                    {{ user.status }}
                  </div>
                </div>
              </div>-->
            </ng-container>
          </app-card>
        </div>
        <div class="merge-card">
          <app-card
            [customHeader]="true"
            blockClass="border-top pro-det-edit collapse show"
          >
            <div class="app-card-header d-flex justify-content-between">
              <h5 class="mb-0">Información de Contacto</h5>
              <button
                type="button"
                (click)="
                  this.editContact = !this.editContact;
                  this.editContactIcon = this.editContact ? 'icon-x' : 'icon-edit';
                  resetValues()
                "
                class="btn btn-primary btn-sm rounded m-0 float-right"
                data-toggle="collapse"
                data-target=".pro-det-edit"
                aria-expanded="false"
                aria-controls="pro-det-edit-1 pro-det-edit-2"
              >
                <i
                  class="feather"
                  [ngClass]="editContactIcon"
                ></i>
              </button>
            </div>
            <div
              class="alert alert-success"
              *ngIf="registration_successful_message != null"
            >
              {{ registration_successful_message }}
            </div>
            <ng-container *ngIf="user && user.userDetails">
              <ng-container *ngIf="!editContact">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label font-weight-bolder">Celular 1</label>
                  <div class="col-sm-9 align-items-center d-flex">
                    {{ user.userDetails.cellPhone }}
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label font-weight-bolder">Celular 2</label>
                  <div class="col-sm-9 align-items-center d-flex">
                    {{ user.userDetails.cellPhone2 }}
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label font-weight-bolder">Teléfono fijo</label>
                  <div class="col-sm-9 align-items-center d-flex">
                    {{ user.userDetails.phone }}
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label font-weight-bolder">Correo</label>
                  <div class="col-sm-9 align-items-center d-flex">
                    {{ user.userDetails.email }}
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="editContact && user.userDetails">
              <div
                class="alert alert-danger"
                *ngIf="registration_error_message != null"
              >
                {{ registration_error_message }}
              </div>
              <form
                [formGroup]="form"
                (ngSubmit)="onSubmit()"
              >
                <div class="form-group row my-2">
                  <label
                    class="col-sm-3 col-form-label font-weight-bolder required"
                    for="celular"
                  >
                    Celular 1
                  </label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      formControlName="cellphone1"
                      id="celular"
                      name="celular"
                      class="form-control"
                      placeholder="Celular"
                    />
                    <small
                      *ngIf="cellphone1Invalid"
                      class="invalid-feedback d-block"
                    >
                      Ingrese un número de celular válido.
                    </small>
                  </div>
                </div>
                <div class="form-group row my-2">
                  <label
                    class="col-sm-3 col-form-label font-weight-bolder"
                    for="celular"
                  >
                    Celular 2
                  </label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      formControlName="cellphone2"
                      id="celular2"
                      name="celular2"
                      class="form-control"
                      placeholder="Celular"
                    />
                  </div>
                </div>
                <div class="form-group row my-2">
                  <label
                    class="col-sm-3 col-form-label font-weight-bolder"
                    for="celular"
                  >
                    Teléfono fijo
                  </label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      formControlName="phone"
                      id="telefono_fijo"
                      name="telefono_fijo"
                      class="form-control"
                      placeholder="Teléfono fijo"
                    />
                  </div>
                </div>
                <div class="form-group row my-2">
                  <label
                    class="col-sm-3 col-form-label font-weight-bolder required"
                    for="email"
                  >
                    Correo
                  </label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      formControlName="email"
                      id="email"
                      name="email"
                      class="form-control"
                      placeholder="Email"
                    />
                    <small
                      *ngIf="emailInvalid"
                      class="invalid-feedback d-block"
                    >
                      Ingrese un correo válido.
                    </small>
                  </div>
                </div>
                <div class="form-group row my-2">
                  <label class="col-sm-3 col-form-label"></label>
                  <div class="col-sm-9">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      value="Guardar"
                    >
                      <span
                        *ngIf="this.isDelay"
                        class="spinner-grow spinner-grow-sm"
                        role="status"
                      ></span>
                      <span
                        *ngIf="this.isDelay"
                        class="load-text"
                      >
                        Procesando...
                      </span>
                      <span
                        *ngIf="!this.isDelay"
                        class="btn-text"
                      >
                        Guardar
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            </ng-container>
          </app-card>
        </div>
        <div
  class="merge-card"
  *ngIf="user"
>
  <app-card
    [customHeader]="true"
    blockClass="border-top pro-det-edit collapse show"
    cardTitle="Seguridad de la cuenta"
  >
    <div class="app-card-header perfil-password-card-header">
      <div class="d-flex justify-content-between align-items-start perfil-password-header-top">
        <div class="perfil-password-header-titles">
          <h5 class="perfil-password-header-title mb-0">Seguridad de la cuenta</h5>
          <span class="perfil-password-header-subtitle">Actualice su contraseña de acceso</span>
        </div>
        <i
          class="feather icon-shield perfil-password-header-icon"
          aria-hidden="true"
        ></i>
      </div>
    </div>

    <div class="perfil-password-card-header">
      <p class="perfil-password-header-hint mb-0 mt-2">
        Use una contraseña segura de al menos 6 caracteres.
      </p>
    </div>

    <form
      class="perfil-password-form pt-3"
      [formGroup]="passwordForm"
      (ngSubmit)="onSubmitPassword()"
    >

      <!-- CONTRASEÑA ACTUAL -->
      <div class="form-group row">
        <label
          class="col-sm-3 col-form-label font-weight-bolder required"
          for="cli-current-password"
        >
          Contraseña actual
        </label>
        <div class="col-sm-9">
          <div class="perfil-password-field">
            <input
              id="cli-current-password"
              [type]="showCurrentPassword ? 'text' : 'password'"
              class="form-control perfil-password-input"
              formControlName="currentPassword"
              autocomplete="current-password"
              [ngClass]="{
                'is-invalid':
                  passwordForm.get('currentPassword')?.invalid &&
                  passwordForm.get('currentPassword')?.touched
              }"
              placeholder="••••••••"
            />
            <button
              type="button"
              class="perfil-password-toggle"
              (click)="showCurrentPassword = !showCurrentPassword"
              [attr.aria-label]="
                showCurrentPassword ? 'Ocultar contraseña actual' : 'Mostrar contraseña actual'
              "
              [attr.aria-pressed]="showCurrentPassword"
            >
              <i
                class="feather"
                [ngClass]="showCurrentPassword ? 'icon-eye-off' : 'icon-eye'"
                aria-hidden="true"
              ></i>
            </button>
          </div>

          <show-error
            [control]="passwordForm.get('currentPassword')!"
            [label]="'su contraseña actual'"
          ></show-error>
        </div>
      </div>

      <!-- NUEVA CONTRASEÑA -->
      <div class="form-group row">
        <label
          class="col-sm-3 col-form-label font-weight-bolder required"
          for="cli-new-password"
        >
          Nueva contraseña
        </label>
        <div class="col-sm-9">
          <div class="perfil-password-field">
            <input
              id="cli-new-password"
              [type]="showNewPassword ? 'text' : 'password'"
              class="form-control perfil-password-input"
              formControlName="newPassword"
              autocomplete="new-password"
              [ngClass]="{
                'is-invalid':
                  passwordForm.get('newPassword')?.invalid &&
                  passwordForm.get('newPassword')?.touched
              }"
              placeholder="Nueva contraseña"
            />
            <button
              type="button"
              class="perfil-password-toggle"
              (click)="showNewPassword = !showNewPassword"
              [attr.aria-label]="
                showNewPassword ? 'Ocultar nueva contraseña' : 'Mostrar nueva contraseña'
              "
              [attr.aria-pressed]="showNewPassword"
            >
              <i
                class="feather"
                [ngClass]="showNewPassword ? 'icon-eye-off' : 'icon-eye'"
                aria-hidden="true"
              ></i>
            </button>
          </div>

          <show-error
            [control]="passwordForm.get('newPassword')!"
            [label]="'la nueva contraseña'"
          ></show-error>
        </div>
      </div>

      <!-- CONFIRMAR CONTRASEÑA -->
      <div class="form-group row">
        <label
          class="col-sm-3 col-form-label font-weight-bolder required"
          for="cli-new-password-confirm"
        >
          Repetir nueva contraseña
        </label>
        <div class="col-sm-9">
          <div class="perfil-password-field">
            <input
              id="cli-new-password-confirm"
              [type]="showNewPasswordConfirmation ? 'text' : 'password'"
              class="form-control perfil-password-input"
              formControlName="newPasswordConfirmation"
              autocomplete="new-password"
              [ngClass]="{
                'is-invalid':
                  passwordForm.get('newPasswordConfirmation')?.invalid &&
                  passwordForm.get('newPasswordConfirmation')?.touched
              }"
              placeholder="Repita la nueva contraseña"
            />
            <button
              type="button"
              class="perfil-password-toggle"
              (click)="showNewPasswordConfirmation = !showNewPasswordConfirmation"
              [attr.aria-label]="
                showNewPasswordConfirmation
                  ? 'Ocultar repetición de contraseña'
                  : 'Mostrar repetición de contraseña'
              "
              [attr.aria-pressed]="showNewPasswordConfirmation"
            >
              <i
                class="feather"
                [ngClass]="showNewPasswordConfirmation ? 'icon-eye-off' : 'icon-eye'"
                aria-hidden="true"
              ></i>
            </button>
          </div>

          <show-error
            [control]="passwordForm.get('newPasswordConfirmation')!"
            [label]="'la confirmación'"
          ></show-error>
        </div>
      </div>

      <!-- BOTÓN -->
      <div class="form-group row submit-row">
        <div class="col-sm-3 d-none d-sm-block"></div>
        <div class="col-sm-9">
          <button
            type="submit"
            class="btn btn-primary px-4"
            [disabled]="isPasswordSubmitting || isPasswordChangeLogoutPending || passwordForm.invalid"
          >
            <span
              *ngIf="isPasswordSubmitting || isPasswordChangeLogoutPending"
              class="spinner-grow spinner-grow-sm me-1"
              role="status"
              aria-hidden="true"
            ></span>
            {{
              isPasswordChangeLogoutPending
                ? 'Cerrando sesión…'
                : isPasswordSubmitting
                  ? 'Actualizando…'
                  : 'Actualizar contraseña'
            }}
          </button>
        </div>
      </div>

    </form>
  </app-card>
</div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
